import React, { useState } from 'react'
import { FileTextOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, DatePicker, Input, List, Modal } from 'antd'
import { array, number } from 'prop-types'
import dayjs from 'dayjs'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { getDocumentsUrl } from 'states/modules/documentDetail'
import PdfCarouselModal from '~/components/PdfCarouselModal'
import FileUpload from '~/components/fileUpload'
import api from 'services/api'

const DocumentsView = ({ document_id, documents = [] }) => {
	const dispatch = useDispatch()
	const documentsUrls = useSelector(
		(state) => state.documentDetail.documentsUrls.data
	)
	const loadingDocuments = useSelector(
		(state) => state.documentDetail.documentsUrls.loading
	)
	const history = useHistory()

	const [visible, setVisible] = useState(false)
	const [currentIndex, setCurrentIndex] = useState(0)
	const [addModalVisible, setAddModalVisible] = useState(false)
	const [newDocumentName, setNewDocumentName] = useState('')
	const [newDocumentDate, setNewDocumentDate] = useState(null)
	const [uploadedFile, setUploadedFile] = useState(null)
	const [uploading, setUploading] = useState(false)

	const openModal = (index) => {
		dispatch(getDocumentsUrl({ id: document_id }))
		setCurrentIndex(index)
		setVisible(true)
	}

	const resetForm = () => {
		setNewDocumentName('')
		setNewDocumentDate(null)
		setUploadedFile(null)
		setUploading(false)
	}

	const handleFileChange = (files) => {
		if (files && files.length > 0) {
			setUploadedFile(files[0])
			setUploading(false)
			return
		}
		setUploadedFile(null)
	}

	const handleAddDocument = async () => {
		if (!uploadedFile || !newDocumentName || !newDocumentDate) {
			return
		}

		const payload = {
			name: newDocumentName,
			filename: uploadedFile.name,
			date: dayjs(newDocumentDate).format('DD/MM/YYYY'),
			uuid: uploadedFile.uid,
		}

		try {
			setUploading(true)
			await api.post(`/documents/${document_id}/add-document`, payload)
			setAddModalVisible(false)
			resetForm()
			history.push(`/documents/${document_id}/edit`)
		} finally {
			setUploading(false)
		}
	}

	const isAddButtonDisabled =
		!newDocumentName || !newDocumentDate || !uploadedFile

	return (
		<div>
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}>
				<h3>Documentos Anexados</h3>
				<Button
					type="primary"
					icon={<PlusOutlined />}
					onClick={() => {
						resetForm()
						setAddModalVisible(true)
					}}>
					Adicionar
				</Button>
			</div>

			{documents.length === 0 ? (
				<div style={{ textAlign: 'center', padding: '40px 0' }}>
					<FileTextOutlined style={{ fontSize: 40, color: '#ccc' }} />
					<p style={{ marginTop: 10, color: '#999' }}>
						Este documento ainda não possui documentos anexados.
					</p>
				</div>
			) : (
				<>
					<List
						itemLayout="horizontal"
						dataSource={documents}
						locale={{ emptyText: 'Nenhum documento anexado.' }}
						renderItem={(item, index) => (
							<List.Item
								onClick={() => openModal(index)}
								style={{ cursor: 'pointer' }}>
								<List.Item.Meta
									avatar={<FileTextOutlined style={{ fontSize: '20px' }} />}
									title={item.name}
									description={item.data}
								/>
							</List.Item>
						)}
					/>

					<PdfCarouselModal
						isVisible={visible}
						onClose={() => setVisible(false)}
						documents={documents}
						urls={documentsUrls}
						loading={loadingDocuments}
						initialIndex={currentIndex}
						title="Documentos Anexados"
					/>
				</>
			)}

			<Modal
				title="Adicionar documento"
				open={addModalVisible}
				onCancel={() => setAddModalVisible(false)}
				onOk={handleAddDocument}
				okText="Adicionar"
				cancelText="Cancelar"
				okButtonProps={{
					disabled: isAddButtonDisabled || uploading,
					loading: uploading,
				}}>
				<div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
					<Input
						placeholder="Nome do documento"
						value={newDocumentName}
						onChange={(e) => setNewDocumentName(e.target.value)}
					/>
					<DatePicker
						style={{ width: '100%' }}
						placeholder="Data"
						format="DD/MM/YYYY"
						value={newDocumentDate}
						onChange={(date) => setNewDocumentDate(date)}
					/>
					<FileUpload
						onChange={handleFileChange}
						multiple={false}
						folder="documents"
					/>
				</div>
			</Modal>
		</div>
	)
}

DocumentsView.propTypes = {
	document_id: number,
	documents: array,
}

export default DocumentsView
